import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

var firebaseConfig = {
  apiKey: "AIzaSyDIczRYlVpznGo8auNT_pNb1-9tz5WhE9I",
  authDomain: "lenkrad-41598.firebaseapp.com",
  projectId: "lenkrad-41598",
  storageBucket: "lenkrad-41598.appspot.com",
  messagingSenderId: "902142138342",
  appId: "1:902142138342:web:9692dfc2f11588b7266827",
  measurementId: "G-9BPJWW9VZT",
};

const firebaseApp = initializeApp(firebaseConfig);
let messaging = getMessaging(firebaseApp);
// console.log(firebaseApp);
// if (firebaseApp.messaging.isSupported()) {
//   messaging = getMessaging(firebaseApp);
// }

export const getUserToken = (setTokenFound) => {
  return getToken(messaging, {
    vapidKey:
      "BEot52OXEpixCAPbMCfvrnz8OA7HnCZm5NSlzje9wLyJqIbeHdnD6YXoCpRq9v8pA3zKyWeSV_lflnrUUUjXAQA",
  })
    .then((currentToken) => {
      if (currentToken) {
        setTokenFound(currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            getUserToken(setTokenFound);
            return;
          }
        });

        setTokenFound(null);
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
